import React, { useEffect, useState } from "react";
import Profile from ".";
import SubscriptionInfo from "../Subscription/subscriptionInfo";

function Account() {
  const [activeTab, setActiveTab] = useState("profile");

  const tabs = [
    { id: "profile", label: "Profile" },
    { id: "plan", label: "Plan & Billings" },
  ];

  useEffect(() => {

  }, [activeTab])

  return (
    <div className="p-4"  style={{minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll"}}>
      {/* Title */}
      <h1 className="album-label mb-6">
        Account
      </h1>

      {/* Tabs */}
      <div className="flex gap-8">
        {tabs.map((tab) => (
          <span
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`relative border-0 t-title transition-colors duration-200 cursor-pointer
              ${
                activeTab === tab.id
                  ? "text-gray-900"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            style={{
              borderBottom : activeTab === tab.id ? "solid 4px rgb(var(--pink))" : ""
            }}
          >
            {tab.label}

            {/* Pink underline */}
            {/* {activeTab === tab.id && (
              <span className="absolute left-0 border-bottom-[2px] h-[4px] w-full bg-pink-500 rounded-full transition-all duration-300">test</span>
            )} */}
          </span>
        ))}
      </div>

      {/* Content */}
      <div className="mt-4">
        {activeTab === "profile" && <div className="w-full flex justify-center"  > <Profile /> </div>}
        {activeTab === "plan" && <div className="w-full flex justify-center"  > <SubscriptionInfo /></div>}
      </div>
    </div>
  );
}

export default Account;
